module.exports = __webpack_public_path__ + "static/media/delhi.fdb78fc8.svg";